<template lang="pug">
  v-container.View.View--CompanyLocationList
    template(v-if="!loading")
      AddToHomeIOSSafariDialog
      template(v-if="locations.length")
        template(v-for="location in locations")
          v-card.pa-3.mb-3(:to="{ name: 'company.list.manage', params: { location: location.id }}")
            .d-flex
              .subtitle-1 {{ location.name }}
              v-spacer
              v-menu(offset-y small)
                template(v-slot:activator="{ on }")
                  v-btn(icon v-on="on" @click.prevent)
                    v-icon mdi-dots-vertical
                v-list(compact)
                  v-list-item(:href="`https://app.openlist.it/#/attivita/${location.id}`" target="_blank")
                    v-icon(left) mdi-eye
                    | Anteprima
                  v-list-item(:to="{ name: 'company.location.edit', params: { location: location.id }}")
                    v-icon(left) mdi-pencil
                    | Modifica
            .subtitle-2 {{ location.city }}, {{ location.address }}, {{ location.province }}
        .text-center.mt-6
          v-btn.success(:to="{ name: 'company.location.create' }" rounded)
            v-icon(left) mdi-plus
            | Aggiungi attività
      template(v-else)
        .text-center
          .subtitle-1.my-6 Nessuna attività registrata.
          v-btn.my-6.success(:to="{ name: 'company.location.create' }" rounded)
            v-icon(left) mdi-plus
            | Aggiungi attività
      HelpAlert.mt-6
    template(v-else)
      Loading
</template>

<script>
import Location from "@/api/Location";
import Loading from "@/components/Loading";
import HelpAlert from "@/components/HelpAlert";
import AddToHomeIOSSafariDialog from "@/components/AddToHomeIOSSafariDialog";

export default {
  name: "CompanyLocationList",
  components: { Loading, HelpAlert, AddToHomeIOSSafariDialog },
  data() {
    return {
      loading: true,

      locations: []
    };
  },

  async mounted() {
    console.log("here");
    this.$emit("update:title", "Le tue attività");
    this.loading = true;
    this.locations = await Location.all();
    this.loading = false;
  }
};
</script>
